import styles from './index.module.sass';
import handsSvg from '@@/seller-account/images/hands.svg';
import logoSvg from '@@/seller-account/images/logo.svg';

export const EmptyMain = () => {
  return (
    <div className={styles.root}>
      <div className={styles.section}>
        <img src={handsSvg} alt="image" />
        <h3>Уже работаете с партнерами-покупателями?</h3>
        <span>Добавьте своих контрагентов и их предложения</span>
      </div>
      <div className={styles.section}>
        <img src={logoSvg} alt="image" />
        <h3>
          Сервис Liliani cможет предоставить <br/>список проверенных партнеров-покупателей
        </h3>
      </div>
    </div>
  );
};
